import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentStep: 1,
  setupData: {
    topic: '',
    tone: '',
    frequency: '',
    contentType: '[]',
    contentLength: '',
    seoFocus: [],
    cta: {
      text: '',
      button_color: '',
      text_color: ''
    },
    targetAudience: '',
    monetizationStrategy: [],
    amazonTag: '',
    adsenseId: '',
    mediaPreferences: [],
    reviewPreference: false,
    hasExistingBlog: false,
    blogDomain: '',
    cmsPlatform: ''
  }
};

const setupWizardSlice = createSlice({
  name: 'setupWizard',
  initialState,
  reducers: {
    setCurrentStep: (state, action) => {
      state.currentStep = action.payload;
    },
    updateSetupData: (state, action) => {
      state.setupData = {
        ...state.setupData,
        ...action.payload
      };
    },
    loadSetupData: (state, action) => {
      const backendData = action.payload;
      state.setupData = {
        ...state.setupData,
        topic: backendData.topic || '',
        tone: backendData.writing_tone || '',
        frequency: backendData.posting_frequency || '',
        contentType: backendData.content_type || '[]',
        contentLength: backendData.content_length || '',
        seoFocus: backendData.seo_focus ? 
          (typeof backendData.seo_focus === 'string' ? 
            JSON.parse(backendData.seo_focus) : 
            backendData.seo_focus) : 
          [],
        cta: {
          text: backendData.cta_text || '',
          button_color: backendData.cta_button_color || '',
          text_color: backendData.cta_text_color || ''
        },
        targetAudience: backendData.target_audience || '',
        monetizationStrategy: backendData.monetization_strategy ? 
          backendData.monetization_strategy.split(',') : [],
        amazonTag: backendData.amazon_tag || '',
        adsenseId: backendData.adsense_id || '',
        mediaPreferences: backendData.media_preferences ? 
          backendData.media_preferences.split(',') : [],
        reviewPreference: backendData.review_preference || false,
        hasExistingBlog: backendData.has_existing_blog || false,
        blogDomain: backendData.blog_domain || '',
        cmsPlatform: backendData.cms_platform || ''
      };
    },
    resetSetupWizard: () => initialState
  }
});

export const { 
  setCurrentStep, 
  updateSetupData, 
  loadSetupData, 
  resetSetupWizard 
} = setupWizardSlice.actions;

export default setupWizardSlice.reducer; 